import React from "react"
import Table from "../../../components/Table/Table"
import { useState, useEffect } from "react"
import axios from "axios"
import { Box, Button, Fade, LinearProgress, Typography } from "@mui/material"
import { useAppDispatch } from "../../../store"
import { setCurrentPage } from "../../../store/auth/authReducer"
import Filter from "../../../components/Filter/Filter"
import { useSelector } from "react-redux"
import { getFilterValues } from "../../../utils/getFilterValues"
import { logOut } from "../../../utils/logOut"
import { CallReportFilterData } from "../../../components/Filter/FilterData"
import TranslatedText from "../../../utils/Translate"
import SimplifiedTable from "../../../components/Table/SimpleTable"
import { useSnackbar } from "../../../utils/SnackbarContext"

export default function CallReport() {
    //Declaring states
    const [tableData, setTableData] = useState([])
    const [loading, setLoading] = useState(false)
    const [openDialog, setOpenDialog] = React.useState(false);
    const [startRow, setStartRow] = useState(0)
    const [pageRows, setPageRows] = useState(100)
    const [maxRows, setMaxRows] = useState(pageRows)
    const [totalRows, setTotalRows] = useState(0)
    
    const { showSnackbar } = useSnackbar();

    //Set header title
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(setCurrentPage('Call Report'))
    }, [dispatch]);

    const filters = useSelector((state: any) => state.filter.filterUserData.callreport)


// Функция для обработки null-значений в массиве объектов
const removeNullKeysFromAllObjects = (arr: any) => {
    if (!Array.isArray(arr) || arr.length === 0) return arr;

    // Собираем все ключи
    const allKeys = new Set<string>();
    arr.forEach(obj => {
        Object.keys(obj).forEach(key => {
            allKeys.add(key);
        });
    });

    // Для каждого ключа определяем, все ли значения null/пустые
    allKeys.forEach(key => {
        const values = arr.map(obj => obj[key]);
        const allNull = values.every(val => val === null || val === '');
        if (allNull) {
            // Если все значения null/пустые — удалить ключ из всех объектов
            arr.forEach(obj => {
                delete obj[key];
            });
        } else {
            // Если есть хотя бы одно не-null — заменить null/пустые на "..."
            arr.forEach(obj => {
                if (obj[key] === null || obj[key] === '') {
                    obj[key] = "...";
                }
            });
        }
    });

    return arr;
};

    //Making a request to get data for a table
    async function fetchData(params: object = {}) {
        setLoading(true)
        try {
            const response = await axios.get('https://cardgarantsales.com/restapi/callreport', {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem('access_token')
                },
                params: { ...params, startRow, maxRows, calculatetotalcount: true }
            })
            if (response.data !== null) {
                if (typeof (response.data) === 'object') {
                    setTotalRows(+response.data[0].totalcount)
                    setTableData(removeNullKeysFromAllObjects(response.data.slice(1)))
                }
                else showSnackbar('ERROR: INVALID SERVER RESPONSE', 'error')
            }
            setLoading(false)
        } catch (error: any) {
            console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                logOut(dispatch)
            }
            else if (error.code === "ERR_NETWORK") {
                showSnackbar('ERROR NETWORK', 'error')
            }
            setLoading(false)
        }
    }
    //on load page send request to get table data with filters
    useEffect(() => {
        fetchData(getFilterValues(filters))
    }, [startRow, maxRows])

    useEffect(() => {
        setMaxRows(pageRows)
        setStartRow(0)
    }, [filters])

    //Pagination buttons
    function handleBack() {
        if ((startRow - pageRows) < 0) {
            setStartRow(0)
            setMaxRows(pageRows)

        }
        else {
            setStartRow((prev) => prev - pageRows)
            setMaxRows((prev) => prev - pageRows)
        }
    }

    function handleNext() {

        setStartRow((prev) => prev + pageRows)
        setMaxRows((prev) => prev + pageRows)

    }

    function handleEnd() {

        setStartRow(totalRows % pageRows === 0 ? totalRows - pageRows : totalRows - (totalRows % pageRows))
        setMaxRows(totalRows % pageRows === 0 ? totalRows : totalRows - (totalRows % pageRows) + pageRows)

    }

    function handleStart() {

        setStartRow(0)
        setMaxRows(pageRows)

    }

    const totalPages = Math.ceil(totalRows / pageRows);
    const currentPage = Math.ceil(maxRows / pageRows);

    const accesslevel = useSelector(
        (state: any) => state.auth.authData.accesslevel
    )

    return (
        <Box sx={{ height: '86vh', display: 'flex', flexDirection: 'column' }}>
            <Filter exclude={accesslevel !== "5" ? ['partnerbank'] : []} fetchData={(params: object) => fetchData(params)} page="callreport" filtersList={CallReportFilterData} />
            {loading ? <LinearProgress sx={{ width: "50%", marginTop: '33vh', marginLeft: 'auto', marginRight: 'auto' }} /> :
                <>
                    {/* <Table rows={typeof (tableData) === 'object' ? tableData : []} page={'callreport'} /> */}
                    <SimplifiedTable rows={typeof (tableData) === 'object' ? tableData : []} page={'callreport'} />
                    <Fade in={!loading} timeout={300}>
                        <Box sx={{ display: 'flex', alignItems: "center", marginTop: 'auto' }}>
                            <Box sx={{ mt: 2 }}>
                                <Button disabled={startRow === 0} onClick={() => handleStart()} size="small" sx={{ mr: 1 }} variant="outlined" >{"<<"}</Button>
                                <Button disabled={startRow === 0} onClick={() => handleBack()} size="small" sx={{ mr: 1 }} variant="outlined" ><span>{'<'}&nbsp;</span> {<TranslatedText text={"Back"} />}</Button>
                                <Button disabled={maxRows >= totalRows} onClick={() => handleNext()} size="small" sx={{ mr: 1 }} variant="outlined" >{<TranslatedText text={'Next'} />}&nbsp;<span>{'>'}</span></Button>
                                <Button disabled={maxRows >= totalRows || tableData.length < pageRows} onClick={() => handleEnd()} size="small" sx={{ mr: 1 }} variant="outlined" >{">>"}</Button>
                            </Box>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Rows on page:'} /> {pageRows}</Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}>
                                <TranslatedText text={'Page:'} /> {currentPage} / {totalPages}
                            </Typography>
                            <Typography sx={{ pt: 2, ml: 2 }}><TranslatedText text={'Total rows:'} /> {totalRows}</Typography>
                        </Box>
                    </Fade>
                </>
            }
        </Box>
    )
}